export default function (num) {
    const date = new Date(num);
    let week = ''
    if (date.getDay() === 0) { week = "星期日" }
    else if (date.getDay() === 1) { week = "星期一" }
    else if (date.getDay() === 2) { week = "星期二" }
    else if (date.getDay() === 3) { week = "星期三" }
    else if (date.getDay() === 4) { week = "星期四" }
    else if (date.getDay() === 5) { week = "星期五" }
    else if (date.getDay() === 6) { week = "星期六" }
    const day = ` ${week} `;
    const dayTitle = day;

    return dayTitle;
}